import { render, staticRenderFns } from "./TestsDelete.vue?vue&type=template&id=7f908c06&"
import script from "./TestsDelete.vue?vue&type=script&lang=js&"
export * from "./TestsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports